import { useState } from 'react';
import ScheduleButton from "../ScheduleComponent/ScheduleButton.jsx";
import ScheduleData from "../../hook/ScheduleData";
import './GroupScheduleChoose.css';

function GroupSchedule() 
{
    const [tab, setTab] = useState('vo'); 

    const voData  = ScheduleData('/Groups', null, true);
    const spoData = ScheduleData('/Groups', null, false);

    const active = tab === 'vo' ? voData : spoData;

    if (active.loading) return <div className='loading'>Загрузка...</div>;
    if (active.error)   return <div className='error'>Ошибка: {active.error}</div>;

    return (
        <div>
            <div className='edu-filter'>
                <button
                    className={`edu-filter__btn vo ${tab === 'vo' ? 'active' : ''}`}
                    onClick={() => setTab('vo')}
                >
                    Высшее образование (ВО)
                </button>
                <button
                    className={`edu-filter__btn spo ${tab === 'spo' ? 'active' : ''}`}
                    onClick={() => setTab('spo')}
                >
                    СПО
                </button>
            </div>

            <ScheduleButton 
                data={active.data}
                url="students"
                title={tab === 'vo' ? 'Группы высшего образования' : 'Группы СПО'}
                displayKey="group_name"
                routeKey="group_name"
                keyField="group_name"
            />
        </div>
    );
}

export default GroupSchedule;